// import { createStore, applyMiddleware } from "redux";
// import reducers, { initialState } from "./reducers";
// import thunk from "redux-thunk";
//
// export const store = createStore(
//   reducers,
//   initialState,
//   applyMiddleware(thunk)
// );

import { configureStore } from "@reduxjs/toolkit";
import reducers, { initialState } from "./reducers";

export const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        thunk: true,
        serializableCheck: false,
    }),
    preloadedState: initialState,
    // redux-thunk is included automatically
});

// Optional: export types for TS
// TypeScript helpers
// Infer the `RootState`,  `AppDispatch`, and `AppStore` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store